export const siteConfig = {
  brandName: "bantrolley",
  orderPrefix: "BANTROLLEY",
  storagePrefix: "bantrolley",
  legalName: "Hong Kong Hongxin Ying Trading Co., Limited",
  tagline: "Thoughtful pieces for considered everyday living.",
  description:
    "A Hong Kong-based collection of useful, tactile home and lifestyle pieces selected for modern living.",
  announcement: "Worldwide tracked delivery for $9.99",
  currency: "USD",
  locale: "en-US",
  shipping: {
    standard: 9.99,
    dispatch: "Dispatched from Hong Kong within 2–4 working days",
  },
  contact: {
    email: "audit@bantrolley.store",
    address: [
      "RM 14, UNIT 12A, 13/F, BLOCK 1",
      "CAMEL PAINT BUILDING",
      "62 HOI YUEN ROAD",
      "Kwun Tong",
      "Hong Kong",
    ],
    openingHours: "Monday to Friday, 10am–6pm HKT",
  },
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 2,
  }).format(Number(value) || 0);

export const getShippingCost = () => siteConfig.shipping.standard;
